var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44531 17.001V16.112C5.44531 15.8785 5.4913 15.6473 5.58066 15.4316C5.67001 15.2159 5.80097 15.0199 5.96608 14.8547C6.13118 14.6896 6.32718 14.5587 6.5429 14.4693C6.75862 14.38 6.98982 14.334 7.22331 14.334H10.7793C11.2509 14.334 11.7031 14.5213 12.0365 14.8547C12.37 15.1882 12.5573 15.6404 12.5573 16.112V17.001",
    stroke: "#0B1B4E",
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4453 7.22266H15.2233C15.6949 7.22266 16.1471 7.40998 16.4805 7.74342C16.814 8.07686 17.0013 8.5291 17.0013 9.00066V9.88966",
    stroke: "#0B1B4E",
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.88966V9.00066C1 8.5291 1.18732 8.07686 1.52076 7.74342C1.8542 7.40998 2.30644 7.22266 2.778 7.22266H4.556",
    stroke: "#0B1B4E",
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4519 4.56C14.4349 4.56 15.2319 3.76307 15.2319 2.78C15.2319 1.79693 14.4349 1 13.4519 1C12.4688 1 11.6719 1.79693 11.6719 2.78C11.6719 3.76307 12.4688 4.56 13.4519 4.56Z",
    stroke: "#0B1B4E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56125 4.56C5.54432 4.56 6.34125 3.76307 6.34125 2.78C6.34125 1.79693 5.54432 1 4.56125 1C3.57818 1 2.78125 1.79693 2.78125 2.78C2.78125 3.76307 3.57818 4.56 4.56125 4.56Z",
    stroke: "#0B1B4E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99875 11.56C9.98182 11.56 10.7787 10.7631 10.7787 9.78C10.7787 8.79693 9.98182 8 8.99875 8C8.01568 8 7.21875 8.79693 7.21875 9.78C7.21875 10.7631 8.01568 11.56 8.99875 11.56Z",
    stroke: "#0B1B4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon);
export default __webpack_public_path__ + "static/media/Team-icon.c555f916ddb48d32a7013191f675eed8.svg";
export { ForwardRef as ReactComponent };